import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Switch } from '../components/ui/switch';
import { Separator } from '../components/ui/separator';
import {
  MoonIcon,
  SunIcon,
  Cog6ToothIcon,
  CheckCircleIcon
} from '@heroicons/react/24/outline';

const SettingsPage = () => {
  const { isDarkMode, toggleDarkMode } = useTheme();

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center gap-3">
        <div className="p-3 rounded-full bg-gradient-to-r from-purple-600 to-blue-600">
          <Cog6ToothIcon className="h-6 w-6 text-white" />
        </div>
        <div>
          <h1 className="text-3xl font-bold">تنظیمات</h1>
          <p className="text-muted-foreground">شخصی‌سازی رقیب‌سنج</p>
        </div>
      </div>

      <Separator />

      {/* تنظیمات ظاهری */}
      <Card className="p-6">
        <div className="flex items-center gap-3 mb-6">
          <h2 className="text-xl font-bold">ظاهر برنامه</h2>
          <Badge variant="secondary">تنظیمات نمایش</Badge>
        </div>

        {/* Dark Mode Toggle */}
        <div className="space-y-4">
          <div className="flex items-center justify-between p-4 rounded-lg border hover:bg-muted/50 transition">
            <div className="flex items-center gap-4">
              <div className={`p-3 rounded-full transition-colors ${
                isDarkMode ? 'bg-slate-800' : 'bg-yellow-100'
              }`}>
                {isDarkMode ? (
                  <MoonIcon className="h-6 w-6 text-blue-400" />
                ) : (
                  <SunIcon className="h-6 w-6 text-yellow-600" />
                )}
              </div>
              <div>
                <h3 className="font-semibold text-base mb-1">حالت تاریک</h3>
                <p className="text-sm text-muted-foreground">
                  {isDarkMode ? 'فعال - چشم‌ها رو حفظ می‌کنه' : 'غیرفعال - روشن و واضح'}
                </p>
              </div>
            </div>

            <Switch
              checked={isDarkMode}
              onCheckedChange={toggleDarkMode}
              className="data-[state=checked]:bg-purple-600"
            />
          </div>

          {/* توضیحات */}
          <Card className="p-4 bg-gradient-to-r from-blue-50 to-purple-50 dark:from-slate-800 dark:to-slate-700 border-blue-200 dark:border-slate-600">
            <div className="flex items-start gap-3">
              <CheckCircleIcon className="h-5 w-5 text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5" />
              <div className="text-sm">
                <p className="font-medium text-blue-900 dark:text-blue-100 mb-1">
                  مزایای حالت تاریک:
                </p>
                <ul className="text-blue-800 dark:text-blue-200 space-y-1 text-xs">
                  <li>• کاهش خستگی چشم در نور کم</li>
                  <li>• صرفه‌جویی در مصرف باتری</li>
                  <li>• ظاهر مدرن و حرفه‌ای</li>
                </ul>
              </div>
            </div>
          </Card>
        </div>
      </Card>

      {/* سایر تنظیمات (آینده) */}
      <Card className="p-6">
        <h2 className="text-xl font-bold mb-4">تنظیمات بیشتر</h2>
        <div className="space-y-3">
          <div className="flex items-center justify-between p-4 rounded-lg border opacity-50">
            <div>
              <h3 className="font-semibold text-sm mb-1">نوتیفیکیشن‌ها</h3>
              <p className="text-xs text-muted-foreground">مدیریت اعلان‌های چت</p>
            </div>
            <Badge variant="outline">به زودی</Badge>
          </div>

          <div className="flex items-center justify-between p-4 rounded-lg border opacity-50">
            <div>
              <h3 className="font-semibold text-sm mb-1">زبان</h3>
              <p className="text-xs text-muted-foreground">فارسی</p>
            </div>
            <Badge variant="outline">به زودی</Badge>
          </div>
        </div>
      </Card>

      {/* اطلاعات */}
      <Card className="p-6 text-center bg-muted/30">
        <p className="text-sm text-muted-foreground">
          رقیب‌سنج باسلام • نسخه 2.0
        </p>
        <p className="text-xs text-muted-foreground mt-2">
          ساخته شده با ❤️ برای فروشندگان باسلام
        </p>
      </Card>
    </div>
  );
};

export default SettingsPage;
